// import { parseScanCodeUtils } from 'pangu-core'
import lodashUtils from '../../../static/js/lodashUtils'
import objectUtil from '../../../static/js/objectUtil'
import * as scanUtils from '../../../static/js/scanUtils'
// import templateUtil from '../..././static/js/templateUtil'
import calculateUtil from '../../../static/js/calculateUtil'

/**
 * 共通的逻辑和方法
 *
 */
export default {
  data() {
    return {
      /********** 扫码解析部分 **********/
      // 单次扫解析的结果，此变量只存储 data 部分
      scanCurrentResult: new Map(),
      // 存储解析的结果，data 是 map 数据结构
      scanResult: {
        success: false,
        origin: null,
        codeType: null,
        print: null,
        data: new Map(),
      },
      // 扫码区表单数据
      scanFormData: {
        [this.dataGoodsInfoKey]: {},
        [this.dataGoodsKeepingKey]: { epc: null, serialNumber: null },
        [this.dataGoodsPreserveKey]: {},
      },
      // 扫码暂存后的 formData
      formDataAfterScan: null,
      // 存储扫码查询到的商品信息
      goodsInfo: {},
      // 上方表格的搜索关键字
      keyword: '',
      // 扫码后与获取的商品 DI 匹配的数据，来获取任务数据（不会显示在上方表格的数据）
      tableData: [],
      // 任务数据（会显示在上方表格中）
      taskData: [],
      // 表格树配置
      treeConfig: {
        rowField: 'id',
        parentField: 'parent',
        expandAll: false,
      },
      // 扫码表单状态：编辑（update）| 新增（create）
      scanStatus: 'create',
      code: '', // 扫码获取到的数据（字符串）
      analysisCodeType: null, // 解析后识别出的码类型
      analysisMessages: [], // 解析后可展示的数据
      warnOrErrorMessage: '', // 警告或错误的提示信息内容
      warnOrErrorMessageType: '', // 提示信息的类型 警告: warn | 错误: error
      mark: [],
      defaultMark: '', // 扫码枪默认标识
      defaultMarkKey: '',
      isBracket: 'YES',
      prevSerialNumber: '', // 分段扫码时，前一次扫码识别到的序列号
      /********** 组件部分 **********/
      // 错误提示，eg. { errors: [{ level: 1, message: '报错啦！', row: 1 }] }
      topRemindErrors: null,
      // 商品 ids
      detailIds: [],
      // 待选择的规格/型号
      medicalData: null,
      // 货位数据
      locationInfo: {},
      // 已选中规格/型号的执行函数，isSelectModel = false 时，重置为 null
      resolveSelectModel: null,
      // RFID 绑定条码的执行函数
      resolveRfidBindModel: null,
      // 是否选择规格
      isSelectModel: false,
      // 是否可提交保存
      isSave: false,
      // 是否可确认提交
      isScanConfirm: true,
      // 是否正在暂存中
      isPureSaving: false,
      // 是否自动确认
      enabledAutoSubmit: true,
      // 扫码输入框可输入状态
      inputDisabled: false,
      // #6805 扫码识别兼容处理后禁止必填校验，第2次请求成功后将此值赋值为true
      disabledValidRequired: false,
      //********** 日期（保质期）反算 **********//
      /*
       * 是否支持双向反算效期 ISCC_TWO_WAY_PERIOD
       *
       * 全部支持: ALL
       * 正向: POSITIVE
       * 逆向: NEGATIVE
       * 不支持: NO
       *
       */
      policy: null,
      //********** 日期（保质期）反算 End **********//
    }
  },
  props: {
    /** @name Store */
    store: { type: Object },
    /** @name 表单数据 */
    formData: { type: Object },
    /** @name 表格数据 */
    dataSource: {
      type: Array,
      default() {
        return []
      },
    },
    /** @name 验收结论的默认值 */
    acceptResultDefault: {
      type: Object,
      default: () => ({
        id: '339f97fd-1da7-42b8-9947-9e776bffa24c',
        code: 'ACCEPT_RESULT_30',
        name: '合格',
      }),
    },
    /** @name 获取商品失败的错误提示信息 */
    queryGoodsErrorMessage: {
      type: String,
      default: '系统找不到对应的商品档案',
    },
    // 可展示的解析结果字段名集
    analysisMessagesOptions: {
      type: Array,
      default() {
        return [
          'productIdent',
          'batchNumber',
          'periodBegin',
          'periodEnd',
          'periodExpire',
          'serialNumber',
          'amount',
        ]
      },
    },
    /** @name 确认提交时，是否禁止清空扫码区域表单 */
    disabledClearForSubmit: {
      type: Boolean,
      default: false,
    },
    /**
     * @name 外部出入的错误提示信息
     * 数据结构:
     * {
     *   type: 'error' | 'warn',
     *   message: ''
     * }
     */
    errorMessage: {
      type: Object,
    },
    /** @name 是否反算日期 */
    isCalcDate: {
      type: Boolean,
      default: true,
    },
    /** @name 识别失败的错误提示信息 */
    analysisErrorMessage: {
      type: String,
      default: '系统无法识别此类信息',
    },
    // 有参照报错的提示信息
    referErrorMessage: {
      type: String,
      default: '此商品不在任务范围内',
    },
    // 已扫数量不正确的提示信息
    amountErrorMessage: {
      type: String,
      default: '累计扫码数量已经超出了待处理数量，请仔细检查！',
    },
    // 未匹配到数据
    nodataErrorMessage: {
      type: String,
      default: '未匹配到数据，或任务已完成',
    },
    // 没有查询到货位的提示信息
    locationErrorMessage: {
      type: String,
      default: '没有查询到货位',
    },
    // #6805 重试成功后的提示信息
    tryRequestMessage: {
      type: String,
      default: '虽然成功检索到商品，但此GS1条码的格式并不规范，PI信息可能无法自动识别',
    },
    /** @name 已超出库存数据范围 */
    availableErrorMessage: {
      type: String,
      default: '操作失败，超出库存数据范围',
    },
    /** @name 未开启序列号管理的错误提示信息 */
    serialErrorMessage: {
      type: String,
      default: '该商品未启用序列号管理',
    },
    /** @name 未包含全球唯一标识的错误提示信息 */
    gtinErrorMessage: {
      type: String,
      default: '请先扫描全球唯一标识',
    },
    // 是否显示弹窗
    value: {
      type: Boolean,
      default: true,
    },
    // 弹窗宽度 或 Input 组件的输入框宽度
    width: {
      type: [String, Number],
      default: '100%',
    },
    // 左侧位置偏移量
    offset: {
      type: Number,
      default: 200,
    },
    // 标题
    title: {
      type: String,
      default: '开始扫码',
    },
    // 是否将弹层放置于 body 内
    transfer: {
      type: Boolean,
      default: true,
    },
    /** @name 扫码输入框（识别商品）的placeholder */
    placeholder: { type: String, default: '请先扫描能够识别商品的条码' },
    // 搜索输入框的 placeholder
    searchPlaceholder: {
      type: String,
      default: '搜索商品',
    },
    /** @name 自定义必填项校验的项 */
    checkArr: {
      type: Array,
      default() {
        // 参考：['batchNumber', 'periodBegin', 'periodEnd', 'registration', 'certification']
        return []
      },
    },
    /** @name 明细ID取值路径 */
    idKey: { type: String },
    /** @name 商品明细取值路径 */
    itemsKey: { type: String, default: 'items' },
    /**
     * @name 扫码区表单项
     * 数据结构:
     * {
     *    code: 'code',
     *    valueKey: 'code',
     *    name: '商品编号',
     *    visiable(可选): true(显示) | false(隐藏)，默认: 显示
     *    style(可选): {width: '125px'},
     *    component(可选): 'Input', 默认: Input
     *    parameter(可选): {
     *      urlQuery: '请求接口地址’,
     *      requestMethod: '请求方法 默认: get',
     *      valueKey(可选): 'value的key, 默认: value',
     *      labelKey(可选): 'label的key, 默认: label'
     *    },
     *    props(可选): {clearable: true}
     * }
     */
    diAreaColumns: {
      type: Array,
      default() {
        return []
      },
    },
    /** @name 查询库存的接口 */
    queryStockOfUrl: { type: String, default: '' },
    /** @name 查询库存的接口方法 */
    queryStockOfMethod: { type: String, default: 'post' },
    /** @name 查询库存的接口参数 */
    queryStockOfParams: { type: Object },
    /** @name 查询库存另一个的接口 */
    queryStockSecondOfUrl: { type: String, default: '' },
    /** @name 查询库存另一个的接口方法 */
    queryStockSecondOfMethod: { type: String, default: 'post' },
    /** @name 查询库存的接口参数 */
    queryStockSecondOfParams: { type: Object },
    /** @name 添加商品明细的接口 */
    createItemOfUrl: { type: String, default: '' },
    /** @name 查询库存的接口方法 */
    createItemOfMethod: { type: String, default: 'post' },
    /** @name 查询库存的接口参数 */
    createItemOfParams: { type: Object },
    periodBeginParamKey: { type: String, default: 'periodBegin' },
    /** @name 自定义事件名（用于配置在按钮上自定义组件） */
    eventName: { type: String, default: 'on-ok-and-continue' },
    /** @name 传递的额外参数，例如：传递给store */
    eventParams: { type: Object },
    /** @name 定义商品数据的属性名。默认:goodsDetail */
    dataGoodsInfoKey: {
      type: String,
      default: 'goodsDetail', // 可能值 goodsDetail / goodsInfo
    },
    /** @name 定义商品数据goodsKeeping的属性名。 */
    dataGoodsKeepingKey: {
      type: String,
      default: 'goodsKeeping', // 可能值 goodsKeeping / goodsStore
    },
    /** @name 定义商品数据preserve的属性名。 */
    dataGoodsPreserveKey: {
      type: String,
      default: 'preserve',
    },
    /** @name 定义返回数据中的已扫数量的属性名。用于确认提交时，验证已扫数量<=待处理数量 */
    dataAmountKey: {
      type: String,
      default: 'amount', // 可能的值 amount
    },
    /** @name 定义返回数据中的盘点数量的属性名。主要适用于`盘点单` */
    dataStockingAmountKey: { type: String, default: 'stockingAmount' },
    /** @name 定义返回数据中的库存可供数量的属性名。用于校验库存数据范围 */
    dataAvailableKey: { type: String, default: 'available' },
    /** @name 定义返回数据中的待处理数量的属性名。用于确认提交时，验证已扫数量<=待处理数量 */
    dataPendingKey: {
      type: String,
      default: 'plan', // 可能的值 plan
    },
    /** @name 获取表格数据详细信息的接口地址 */
    tableDataInfoUrl: { type: String, default: '' },
    /** @name 获取表格数据详细信息的接口请求方法 */
    tableDataInfoMethod: { type: String },
    /** @name 获取表格数据详细信息的接口的传递参数 */
    tableDataInfoParameters: { type: Object },
    /** @name 获取保质期的接口地址 */
    validDateUrl: { type: String, default: 'rest/main/goods/goods/queryPeriod' },
    /** @name 保存接口地址 */
    saveUrl: { type: String, default: '' },
    /** @name 请求保存接口的参数 */
    saveParams: { type: Object },
    /** @name 扫码获取货位的数据 */
    locationScanInfoUrl: { type: String, default: 'rest/ezscc/scan/scanLocation' },
    /** @name 扫码获取货位的数据的接口参数 */
    locationScanInfoParams: { type: Object },
    /** @name 扫码获取推荐货位的接口 */
    locationScanInfoOfRecommend: { type: String, default: 'rest/ezscc/store/getRecommendLocation' },
    /** @name 扫码获取推荐货位的接口参数 */
    locationScanInfoOfRecommendParams: { type: Object },
    /** @name 是否禁止保存时真实保存 */
    disabledPureSave: { type: Boolean, default: false },
    /** @name 扫码结果暂存服务端的暂存接口地址 */
    pureSaveOfUrl: { type: String, default: 'rest/main/store/receipt/draft' },
    /** @name 表单项【效期】后面，是否显示，“无值”按钮 */
    showEmptyBtn: { type: Boolean, default: true },
    /** @name 是否可设置扫码商品属性 */
    isScanProperty: { type: Boolean, default: false },
    /** @name 组件setGoodOfScanProperty.vue的props，请参考它的Props设置 */
    scanPropertyProps: { type: Object },
    /** @name 配置此prop，则按钮【设置商品扫码属性】会校验用户是否有权限操作此按钮。注意！！！需要同步配置按钮SET_GOODS_PROPERTY，并且别名加上走权限 */
    buttonMenuListUrl: { type: String, default: '' },
    /** @name 配置请求buttonMenuListUrl的参数 */
    buttonMenuListParams: { type: Object },
    /**
     * @name 设置商品扫码属性按钮的别名，会控制按钮是否显示（是否有操作权限）
     * @description 接口返回的 item.alias 和 props.setPropertyAlias 相等则具备操作权限，或者 item.alias 为空则不参与权限控制
     */
    setPropertyAlias: {
      type: String,
      default: 'GOODS_PROPERTY',
    },
    /**
     * @name 必填校验策略（数量、商品编码必校验）
     * @description 可选值: 校验商品档案中的必填字段='validSetting'
     */
    validStrategy: {
      type: Array,
      default() {
        return []
      },
    },
    /** @name 通过扫码添加明细时触发反算的工具类（为null时不触发反算） */
    useBackCountAddItems: {
      type: String,
      default: 'orderBackCountUtil',
    },
    /**
     * @name 校验商品安全目录的表单属性路径
     * @description
     * 示例:
     * 取值 this.formData = {
     *   firstFormData: {
     *     inWarehouse: { id, code, name }
     *   }
     * }
     * 则可配置为 "validSecureCatalogueOfFormDataKey": "firstFormData"
     */
    validSecureCatalogueOfFormDataKey: {
      type: String,
    },
    /** @name 校验商品安全目录的接口的请求地址 */
    validSecureCatalogueOfUrl: {
      type: String,
      default: '',
    },
    /** @name 校验商品安全目录的接口的请求参数 */
    validSecureCatalogueOfParams: {
      type: Object,
      default() {
        return {}
      },
    },
    /** @name 校验商品安全目录的接口的请求方法 */
    validSecureCatalogueOfMethod: {
      type: String,
      default: 'post',
    },
    /** @name 校验商品安全目录的提示 */
    validSecureCatalogueOfMsg: {
      type: String,
      default: '商品不在库存目录中',
    },
    /** @name 是否支持医院RFID标签打印条码 */
    isRfidEpc: {
      type: Boolean,
      default: false,
    },
    /** @name 是否开启根据系统策略IWMS_SCAN_AUTO_OPEN_SERIAL的值判断是否扫码自动开启序列号管理 */
    isCheckAutoSerial: {
      type: Boolean,
      default: false,
    },
    /** @name 扫码识别兼容处理请求成功后是否弹出提示信(此值为true时，第二次请求会忽略必填校验)，相关需求#6805 */
    isTryRequest: { type: Boolean, default: false },
    /** @name #6769,扫码出库按【近效先出】和【先进先出】原则自动匹配的接口地址 */
    stockAutoUrl: { type: String, default: '' },
    /** @name #6769,扫码出库按【近效先出】和【先进先出】原则自动匹配的接口参数 */
    stockAutoParams: { type: Object },
    /** @name 自定义批号的key(适用范围：仅仅只是修改queryStockOfParams，例如：将原来的batchNumber改为batchNumberAccurate) */
    stockBatchNumberProp: { type: String },
    /** @name 自定义序列号的key(适用范围：仅仅只是修改queryStockOfParams，例如：将原来的serialNumber改为serialNumberAccurate)) */
    stockSerialNumberProp: { type: String },

    /** @name #8927 是否开启从序列号截取批号 */
    openSerialCutBatchNumber: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    cacheId() {
      const formData = this.store?.states.formData
      const orderCode = objectUtil.getValueByPath(formData, 'order.code')
      const organizationId = objectUtil.getValueByPath(formData, 'organization.id')
      console.log(`${organizationId}_${orderCode}__setBatchNumber_formData__`)
      return `${organizationId}_${orderCode}__setBatchNumber_formData__`
    },
    filterTableData() {
      const keyword = this.keyword
      const dataGoodsInfoKey = this.dataGoodsInfoKey

      console.log('是否启用单条模式: ', this.isSingle)
      /** @name 启用单条模式 */
      if (this.isSingle) {
        console.log('---------- 启用单条模式 ----------')
        let data = this.taskData ?? []

        if (!lodashUtils.isNone(keyword)) {
          const regx = new RegExp(keyword, 'ig')
          data = data.filter(
            (row) =>
              regx.test(row[dataGoodsInfoKey]?.name) || regx.test(row[dataGoodsInfoKey]?.code)
          )
        }

        this.treeConfig.expandAll = data.length < 100
        return data
      }

      console.log('---------- 关闭单条模式 ----------')
      /** @name 关闭单条模式 */
      let _data = this.tableData ?? []

      if (!lodashUtils.isNone(keyword)) {
        const regx = new RegExp(keyword, 'ig')
        _data = _data.filter(
          (row) => regx.test(row[dataGoodsInfoKey]?.name) || regx.test(row[dataGoodsInfoKey]?.code)
        )
      }

      this.treeConfig.expandAll = _data.length < 200
      return _data
    },
    // 当前扫码类型
    currentScanType() {
      const map = {
        AUTO: ['hibc', 'ma', 'gs1', 'hw'],
        GS1: ['gs1'],
        HIBC: ['hibc'],
        MA: ['ma'],
      }

      return map[this.scanType]
    },
    // 扫码后获取到的商品，是否开启单品序列号管理
    keepingSerial() {
      return this.scanFormData[this.dataGoodsInfoKey]?.keepingSerial
    },
    // 扫码后获取到的商品，是否开启单品自定义序列号管理
    keepingCustomSerial() {
      return (
        this.scanFormData[this.dataGoodsInfoKey]?.keepingCustomSerial ||
        this.scanFormData[this.dataGoodsInfoKey]?.keepingRfidSerial ||
        this.scanFormData[this.dataGoodsInfoKey]?.keepingExclusiveSerial
      )
    },
    // 系统类型是否是灵科
    isLinkOfSystem() {
      return this.dataGoodsKeepingKey === 'goodsStore'
    },
    // 验收结论的 key
    acceptResultKey() {
      return this.isLinkOfSystem ? 'acceptStatus' : 'attrs.valueEnum.acceptResult'
    },
    // 单据
    order() {
      return this.formData?.order
    },
    // 单据 id
    orderId() {
      const route = this.$route || window.$vueApp.$route
      const orderId = this.formData?.order?.id
      return orderId ?? route?.query?.id
    },
    goodsSetting() {
      // 找到商品档案中的必填字段
      const goodsSetting =
        objectUtil.getValueByPath(this.goodsInfo, 'setting') ||
        objectUtil.getValueByPath(this.scanFormData, `${this.dataGoodsInfoKey}.setting`) ||
        {}
      return goodsSetting
    },
    // 需求#6553，新增的系统策略IWMS_SCAN_AUTO_OPEN_SERIAL
    isAutoSerial() {
      return (
        !this.isCheckAutoSerial ||
        objectUtil.getValueByPath(
          this.$store,
          'state.strategy.strategy.IWMS_SCAN_AUTO_OPEN_SERIAL'
        ) === 'YES'
      )
    },
    /********** 需求#5711，验收环节扫码组件的日期处理优化 **********/
    // 是否正向计算
    isPositive() {
      const policy = this.policy
      // 是否进行正向计算
      const isPositive = !policy || policy === 'ALL' || policy === 'POSITIVE'

      console.log('是否进行正向计算: ', isPositive)
      return isPositive
    },
    // 是否逆向计算
    isNegative() {
      const policy = this.policy
      // 是否进行逆向计算
      const isNegative = policy === 'ALL' || policy === 'NEGATIVE'

      console.log('是否进行逆向计算: ', isNegative)
      return isNegative
    },
    /********** 需求#5711，验收环节扫码组件的日期处理优化 End **********/
  },
  watch: {
    scanResult: {
      handler(data) {
        console.log('当前存储的解析数据: ', data)
      },
      deep: true,
    },
    scanFormData: {
      handler: lodashUtils.debounce(function (data) {
        console.log('当前扫码表单数据: ', data)
        if (this.warnOrErrorMessageType === 'error') return

        this.$nextTick(() => {
          const num = data?.[this.dataAmountKey]
          if (num === 0) this.scanFormData[this.dataAmountKey] = 1
        })
      }, 1500),
      deep: true,
    },
    tableData: {
      handler(data) {
        console.log('table data: ', data)
      },
      deep: true,
    },
    taskData: {
      handler(data) {
        console.log('task data: ', data)
        if (data?.length === 0) this.isSave = false
      },
      deep: true,
    },
    scanTableData: {
      handler(data) {
        this.$nextTick(() => {
          // this.calcTableHeight() // 下方表格高度发生变化时，重新计算上方表格的高度
          if (data && data.length > 0) this.$refs?.scanTable?.setCurrentRow(data[0])
        })
      },
      deep: true,
    },
    goodsInfo(goods) {
      console.log('goodsInfo: ', goods)
      if (this.type === 'epc') {
        // 自定义序列号添加，更新 scanFormData
        const val = {
          ...this.scanFormData,
          ...{ [this.dataGoodsInfoKey]: goods },
        }

        objectUtil.setValueByPath(this, 'scanFormData', val)
      }
    },
    isSelectModel(val) {
      // this.isSelectModel = false 时，this.resolveSelectModel 重置为 null
      if (!val) {
        this.resolveSelectModel = null
        // this.disabledInputStatus(false) // 重置扫码输入框的可输入状态
      }
    },
    medicalData(val) {
      if (!val) this.isSelectModel = false
    },
  },
  created() {
    this.defaultMark = objectUtil.getValueByPath(
      this.$store,
      'state.strategy.strategy.IECM_GS1_FNC1_SWEEPING_GUN',
      '96,98,105'
    )
    this.defaultMarkKey = objectUtil.getValueByPath(
      this.store,
      'state.strategy.strategy.IECM_GS1_FNC1_SWEEPING_GUN_COMBINATION',
      'altKey'
    )
    this.isBracket = objectUtil.getValueByPath(
      this.$store,
      'state.strategy.strategy.ISCC_ORIGIN_BARCODE_BRACKET',
      'YES'
    )
    // console.log('$store: ', this.$store)
    // console.log('isBracket: ', this.isBracket)
    // 获取策略
    this.getPolicySetting(true)
  },
  methods: {
    // 禁止扫码输入框的可输入状态
    disabledInputStatus(status = false) {
      this.inputDisabled = status
      // 焦点自动移入扫码输入框
      this.$nextTick(() => {
        this.$refs.areaScanInput?.focus()
      })
    },
    // 打印 Map 数据结构的数据
    consoleMap(data) {
      for (let [key, value] of data) {
        console.log(key, value)
      }
    },
    /**
     * @name 指定重试次数发起请求
     * @description #6805
     *
     * @param {Function} fn 请求方法(函数)
     * @param {Object} [params={}] 请求参数
     * @param {Boolean} [showWarning=false] 重试第2次时是否显示提示信息
     *
     */
    tryRequest(fn, params = {}, showWarning = false) {
      // 重试次数
      let count = 0
      // 兼容处理请求，按照需求 #6805 的验收标准：第二次检索商品档案：将识别到的字符串，去掉开头的(01)后，再截取头14位，再次去寻找商品
      const setParam = (_param) => {
        const param = { ..._param }
        if ('gtin' in param) {
          let gtin = param.gtin
          gtin = gtin.replace(/^01/, '')
          gtin = gtin.substring(0, 14)
          param.gtin = gtin
        }

        return param
      }

      /**
       * @param {Number} [num=1] 指定的重试次数
       */
      return async (num = 1) => {
        try {
          const res = await fn(params)

          // 重试第2次时是否显示提示信息
          if (showWarning) {
            this.updateWarnOrErrorMessage(this.tryRequestMessage, 'warn')
          }
          count = 0 // 重置次数
          return res
        } catch (error) {
          count += 1

          // isTryRequest = false 会查询两次（会正常触发必填校验）
          // isTryRequest = true 则依然查询两次，但不触发必填校验
          if (count < num) {
            // 开启禁止必填校验的开关
            this.disabledValidRequired = this.isTryRequest
            const _params = setParam(params)
            return this.tryRequest(fn, _params, true)(1)
          }

          count = 0 // 重置次数
          throw new Error(error?.message)
        }
      }
    },
    /**
     * @name  根据扫的条码生成厂家原始条码
     * @description 需要在调用 onClear 之前执行
     */
    createOriginBarCode() {
      // #6553,根据系统策略判断是否写入厂家原始条码
      // if (!this.isAutoSerial) return
      const scanData = this.scanCurrentResult
      const scanPrint = this.scanResult.print
      const scanOrigin = this.scanResult.origin
      const gtin = scanData.get('gtin')
      const originBarCodeValue = objectUtil.getValueByPath(
        this.scanFormData,
        `${this.dataGoodsKeepingKey}.originBarCode`
      )
      const originBarCodeDisplayValue = objectUtil.getValueByPath(
        this.scanFormData,
        `${this.dataGoodsKeepingKey}.originBarCodeDisplay`
      )
      const serialNumber = objectUtil.getValueByPath(
        this.scanFormData,
        `${this.dataGoodsKeepingKey}.serialNumber`
      )
      console.log('originBarCodeValue: ', originBarCodeValue)
      console.log('originBarCodeDisplayValue: ', originBarCodeDisplayValue)

      // #33576，扫69码，没有拼出原厂条码字段
      const codeType = this.scanResult.codeType
      const scanType = this.getScanType()
      let { isMa, isHibc } = scanType

      const haveBracket = codeType && !isMa && !isHibc && this.isBracket === 'YES'
      const printBracketValue = haveBracket ? scanPrint?.bracket : scanPrint?.ordinary

      // 扫到 DI
      if (gtin?.startsWith('01')) {
        if (serialNumber) this.prevSerialNumber = serialNumber
        if (scanOrigin) {
          objectUtil.setValueByPath(
            this.scanFormData,
            `${this.dataGoodsKeepingKey}.originBarCode`,
            scanOrigin
          )
        }
        if (printBracketValue) {
          objectUtil.setValueByPathForVue(
            this.scanFormData,
            `${this.dataGoodsKeepingKey}.originBarCodeDisplay`,
            printBracketValue,
            this
          )
        }
      }
      // 分段扫
      else if (`${originBarCodeValue || ''}`.indexOf(scanOrigin) < 0) {
        // eslint-disable-next-line no-inner-declarations
        const updateDisplayCode = (source, target) => {
          const regx = /\((21|91)\).*?(\(|$)/
          if (!regx.test(source)) return source + target
          return source.replace(regx, target + '(').replace(/\($/, '')
        }
        const updateCode = (code, sep) => {
          return code.replace(/^\(/, '').replace(/\(/g, sep).replace(/\)/g, '')
        }

        let separator = 'ñ'
        if (isMa || isHibc) separator = ''
        if (printBracketValue) {
          objectUtil.setValueByPathForVue(
            this.scanFormData,
            `${this.dataGoodsKeepingKey}.originBarCodeDisplay`,
            originBarCodeDisplayValue && /\(|\[/.test(originBarCodeDisplayValue)
              ? // #37522
                updateDisplayCode(originBarCodeDisplayValue, printBracketValue)
              : printBracketValue,
            this
          )

          console.log(
            'originBarCodeDisplay',
            updateDisplayCode(originBarCodeDisplayValue, printBracketValue)
          )
        }
        if (scanOrigin) {
          const originBarCodeDisplay = objectUtil.getValueByPath(
            this.scanFormData,
            `${this.dataGoodsKeepingKey}.originBarCodeDisplay`
          )
          objectUtil.setValueByPath(
            this.scanFormData,
            `${this.dataGoodsKeepingKey}.originBarCode`,
            originBarCodeValue
              ? // #37522
                updateCode(originBarCodeDisplay, separator)
              : scanOrigin
          )

          console.log('originBarCode: ', updateCode(originBarCodeDisplay, separator))
        }

        if (serialNumber) this.prevSerialNumber = serialNumber
      }
    },
    /** @name 添加商品明细 */
    async createItem(params) {
      if (!this.createItemOfUrl) return []
      // 参数
      const newParams = {
        ...this.createItemOfParams,
        ...params,
        parameters: {
          ...this.createItemOfParams?.parameters,
          ...params?.parameters,
        },
      }
      // 添加商品明细时，后端接口会根据传递的生产日期，确定如何带出生产许可证号和注册证号
      const periodBegin = objectUtil.getValueByPath(
        this.scanFormData,
        `${this.dataGoodsKeepingKey}.periodBegin`
      )
      if (periodBegin)
        newParams.parameters[this.periodBeginParamKey] =
          this.periodBeginParamKey === 'periodBeginList' ? [periodBegin] : periodBegin
      // 调用添加商品明细接口
      const res = await this.$axios[this.createItemOfMethod ?? 'post'](
        this.createItemOfUrl,
        newParams
      ).catch((error) => {
        console.error(error?.message)
      })
      if (res.data?.errors) throw new Error(res.data.errors?.[0]?.message ?? '发生异常')
      if (res.data?.code !== 200) throw new Error(res.data?.msg)

      if (res.data?.data?.length > 0) return res.data?.data

      throw new Error(res.data?.msg || '添加商品明细失败')
    },
    /** @name 查询库存信息 */
    async searchStock(params) {
      console.log('mixins 中 查询库存信息')
      if (!this.queryStockOfUrl) return []
      const tmpurl =
        this.type === 'epc'
          ? this.queryStockOfUrl
          : this.queryStockSecondOfUrl || this.queryStockOfUrl
      const stockParams =
        this.type === 'epc'
          ? { ...this.queryStockOfParams, parameters: { ...this.queryStockOfParams?.parameters } }
          : {
              ...(this.queryStockSecondOfParams || this.queryStockOfParams),
              parameters: {
                ...(this.queryStockSecondOfParams?.parameters ||
                  this.queryStockOfParams?.parameters),
              },
            }
      // 调用添加商品明细接口
      const newParams = {
        // 查询库存信息，默认设置：pageNo=1，pageSize=999
        pageNo: 1,
        pageSize: 999,
        ...stockParams,
        ...params,
        parameters: {
          clearAmountOut: true,
          items: this.store?.states?.formData?.items, // 配置或scanStore的优先级更高，会覆盖此项的值
          ...stockParams?.parameters,
          ...params?.parameters,
        },
      }
      if (this.type !== 'epc') delete newParams.parameters.epc
      // 如果是灵科，则增加参数 ifLink=yes
      if (this.isLinkOfSystem) {
        objectUtil.setValueByPath(newParams, 'parameters.ifLink', 'yes')
      }
      // #34036，优先使用失效日期（17）来匹配库存，如果失效日期（17）和有效期至（12）都有值，则使用失效日期（17）来匹配
      const periodExpire = objectUtil.getValueByPath(newParams.parameters, 'periodExpire')
      if (periodExpire) {
        objectUtil.setValueByPath(newParams.parameters, 'periodEnd', periodExpire)
        // 删除 periodExpire 属性
        delete newParams.parameters.periodExpire
      }

      console.warn('---------- 查询库存的参数: ', newParams)
      const res = await this.$axios[this.queryStockOfMethod ?? 'post'](tmpurl, {
        ...newParams,
        parameters: { ...this.fixParameters(newParams.parameters, this.type === 'epc') },
      }).catch((error) => {
        console.error(error?.message)
      })
      if (res.data?.errors) throw new Error(res.data.errors?.[0]?.message ?? '发生异常')
      if (res.data?.code !== 200) throw new Error(res.data?.msg)

      return res.data?.data ?? []
    },
    /**
     * 扫货位码的处理
     *
     * @param {string} [id] 商品id，未传入时取 this.scanFormData[this.dataGoodsInfoKey].id
     *
     */
    async setLocationOfValue() {
      const detailId = objectUtil.getValueByPath(this.scanFormData, `${this.dataGoodsInfoKey}.id`)
      const sid = this.scanFormData[this.dataGoodsInfoKey].id
      const scanid = this.scanTableData[0]?.[this.dataGoodsInfoKey]?.id || sid
      /*
       * 修复BUG #31249
       *
       * 推荐货位没有展示出来，原因是扫码类别选择“自定义序列号”时，this.scanFormData?.[this.dataGoodsInfoKey]?.id 无值
       * 所以此处取值 this.scanTableData[0]?.[this.dataGoodsInfoKey]?.id
       *
       */
      const id = !detailId ? scanid : sid
      const locationItem = this.searchFormItem('location')
      const { data: scanData } = this.scanResult
      let hasLocation = false // 是否配置了货位
      // 是否是推荐货位
      const warehouseId =
        locationItem?.parameter?.requestParameters?.params?.id ||
        this.scanTableDataInfoParam?.warehouseId
      if (locationItem?.isRecommend) {
        const goodsId = id
        const res = await this.$axios.get(this.locationScanInfoOfRecommend, {
          ...this.locationScanInfoOfRecommendParams,
          params: { ...this.locationScanInfoOfRecommendParams?.params, warehouseId, goodsId },
        })
        if (res.data?.code === 200) {
          const locationInfo = res.data?.data
          this.$set(locationItem, 'tip', locationInfo?.name)
          console.log(this.piAreaColumns)
          this.$forceUpdate() // 强制更新
        }
      }
      const { isHw } = this.getScanType()
      if (!isHw) return
      // 判断是否配置了货位的表单项
      if (locationItem) hasLocation = true
      if (!hasLocation) {
        // 没有配置货位
        this.updateWarnOrErrorMessage('没有配置货位', 'error')
        return
      }
      // 配置了货位, 带上仓库 warehouseId
      const location = await this.getLocationInfo(scanData.get('hw'), { warehouseId })
      if (location) {
        scanData.set('location', location)
        // this.updateScanFormDataForOther()
      } else {
        this.updateWarnOrErrorMessage(this.locationErrorMessage, 'error')
      }
    },
    // 查找是否配置了注册证项
    findRegistrationItem() {
      const arr = [
        ...(this.diAreaColumns || []),
        ...(this.piAreaColumns || []),
        ...(this.otherAreaColumns || []),
      ]
      const result = arr.findIndex(
        (column) => column.code === `${this.dataGoodsKeepingKey}.registration`
      )

      return result > -1
    },
    /**
     * 根据获取到的生产日期的值，带出注册证号和生产许可证号的值
     *
     */
    setRegistAndCertificOfValue(url) {
      console.log('根据获取到的生产日期的值，带出注册证号和生产许可证号的值')
      return new Promise((resolve) => {
        const scanData = this.scanResult.data
        const period =
          this.scanFormData[this.dataGoodsKeepingKey]?.periodBegin ?? scanData.get('periodBegin')
        const goodsId = this.scanFormData[this.dataGoodsInfoKey].id
        const parameters = { params: { period, goodsId } }
        // 判断是否配置了注册证项
        const isRegistrationItem = this.findRegistrationItem()

        console.log('是否已配置注册证项: ', isRegistrationItem)
        if (period && goodsId && isRegistrationItem) {
          //这个地方取不到受托企业信息 直接换了接口由原来的selectCertsByPeriod->selectCertsByPeriodV2
          this.$axios
            .get(url, parameters)
            .then((res) => {
              if (res.data.code == 200) {
                const data = res.data.data

                // 判断表单内是否有注册证号和生产许可证号
                const arr = [
                  ...(this.diAreaColumns || []),
                  ...(this.piAreaColumns || []),
                  ...(this.otherAreaColumns || []),
                ]
                arr.forEach((column) => {
                  if (column.code === `${this.dataGoodsKeepingKey}.registration`) {
                    this.$set(
                      this.scanFormData[this.dataGoodsKeepingKey],
                      'registration',
                      data.registration
                    )

                    // 是否是灵科
                    const isLink = this.dataGoodsKeepingKey === 'goodsStore'
                    // 将生产企业放到scanFormData信息里面（添加至明细里）
                    const manufacturer = data.manufacturer
                    const manufacturerProp = `manufacturer${isLink ? 'Name' : ''}`
                    this.$set(
                      this.scanFormData[this.dataGoodsInfoKey],
                      manufacturerProp,
                      manufacturer
                    )
                    // // 是否是灵科
                    // const isLink = this.dataGoodsKeepingKey === 'goodsStore'
                    // // 将生产企业放到scanFormData信息里面（添加至明细里）
                    // const manufacturer = isLink ? data.manufacturerName : data.manufacturer
                    // const manufacturerProp = `manufacturer${isLink ? 'Name' : ''}`
                    // this.$set(
                    //   this.scanFormData[this.dataGoodsInfoKey],
                    //   manufacturerProp,
                    //   manufacturer
                    // )
                  }

                  if (column.code === `${this.dataGoodsKeepingKey}.certification`) {
                    this.$set(
                      this.scanFormData[this.dataGoodsKeepingKey],
                      'certification',
                      data.certification
                    )
                  }
                })
              } else {
                if (res.data?.msg) {
                  this.$pgMessage.confirm({
                    title: '提示',
                    content: res.data.msg,
                  })
                }
              }
              resolve()
            })
            .catch((error) => {
              console.error(error)
              resolve()
            })
        } else {
          resolve()
        }
      })
    },
    /**
     * 根据获取到的注册证号，带出生产许可证号的值
     *
     */
    setCertificOfValue(url, registration) {
      console.log('根据获取到的注册证号，带出生产许可证号的值', registration)
      return new Promise((resolve) => {
        const scanData = this.scanResult.data
        const period =
          this.scanFormData[this.dataGoodsKeepingKey]?.periodBegin ?? scanData.get('periodBegin')
        const goodsId = this.scanFormData[this.dataGoodsInfoKey].id
        const param = {
          ...this.queryCertificationParams,
          parameters: {
            ...this.queryCertificationParams?.parameters,
            period,
            goodsId,
            registration,
          },
        }
        // 判断是否配置了注册证项
        const isRegistrationItem = this.findRegistrationItem()

        console.log('是否已配置注册证项: ', isRegistrationItem)
        if (url && goodsId && registration && isRegistrationItem) {
          //这个地方取不到受托企业信息 直接换了接口由原来的selectCertsByPeriod->selectCertsByPeriodV2
          this.$axios
            .post(url, param)
            .then((res) => {
              if (res.data.code == 200) {
                const data = res.data.data
                const isArray = Array.isArray(data)

                // 判断表单内是否有注册证号和生产许可证号
                const arr = [
                  ...(this.diAreaColumns || []),
                  ...(this.piAreaColumns || []),
                  ...(this.otherAreaColumns || []),
                ]
                arr.forEach((column) => {
                  if (column.code === `${this.dataGoodsKeepingKey}.registration`) {
                    // 是否是灵科
                    const isLink = this.dataGoodsKeepingKey === 'goodsStore'
                    // 将生产企业放到scanFormData信息里面（添加至明细里）
                    const manufacturer = isLink
                      ? registration.manufacturerName
                      : registration.manufacturer
                    const manufacturerProp = `manufacturer${isLink ? 'Name' : ''}`
                    this.$set(
                      this.scanFormData[this.dataGoodsInfoKey],
                      manufacturerProp,
                      manufacturer
                    )
                  }

                  if (column.code === `${this.dataGoodsKeepingKey}.certification`) {
                    console.log('更新注册证 certification: ', data)

                    if (!isArray || data?.length === 1) {
                      const certification = isArray ? data[0] : data
                      this.$set(
                        this.scanFormData[this.dataGoodsKeepingKey],
                        'certification',
                        certification
                      )
                    } else {
                      this.$set(this.scanFormData[this.dataGoodsKeepingKey], 'certification', null)
                    }
                  }
                })
              } else {
                this.$set(this.scanFormData[this.dataGoodsKeepingKey], 'certification', null)
              }
              resolve()
            })
            .catch((error) => {
              console.error(error)
              resolve()
            })
        } else {
          if (isRegistrationItem && !registration) {
            this.$set(this.scanFormData[this.dataGoodsKeepingKey], 'certification', null)
          }
          resolve()
        }
      })
    },
    /**
     * 根据策略反算结果，更新所有日期相关的值
     *
     */
    async setPeriodOfValue() {
      // 保质期推算获取到的日期
      const calc = this.calcPeriod()
      // 更新日期
      if (calc?.periodBegin) {
        objectUtil.setValueByPathForVue(
          this.scanFormData[this.dataGoodsKeepingKey],
          'periodBegin',
          calc.periodBegin,
          this
        )
      }
      if (calc?.periodEnd) {
        objectUtil.setValueByPathForVue(
          this.scanFormData[this.dataGoodsKeepingKey],
          'periodEnd',
          calc.periodEnd,
          this
        )
      }
    },
    /**
     * 反算日期
     *
     * 将现有的【按日】推算方式，细分为两个算法，假设商品的保质期是5年
     * 1、按日：
     * 1.1、正向推算：假设录入的生产日期=2021年3月3日，那么系统自动推算出的效期=2026年3月2日；
     * 1.2、逆向推算：假设录入的效期=2026年3月2日，那么系统自动推算出的生产日期=2021年3月3日；
     * 注：按月、按年以上面的逻辑实现
     *
     * 2、按日（失效日期）：
     * 2.1、正向推算：假设录入的生产日期=2021年3月3日，那么系统自动推算出的效期=2026年3月3日；
     * 2.2、逆向推算：假设录入的效期=2026年3月3日，那么系统自动推算出的生产日期=2021年3月3日；
     *
     * @returns {Object} { periodBegin, periodEnd }
     */
    calcPeriod() {
      // 使用单次扫码解析的结果，否则会出现 Bug#32513 的问题
      const scanData = this.scanCurrentResult
      this.consoleMap(scanData)
      // 扫码获取到的日期
      const scan = {
        periodBegin: scanData.get('periodBegin'),
        periodEnd: scanData.get('periodEnd'),
        periodExpire: scanData.get('periodExpire'),
      }
      // 效期(#34024)
      const _periodEnd = scan.periodExpire || scan.periodEnd

      let result = {
        periodBegin: scan.periodBegin,
        periodEnd: _periodEnd,
      }

      // 是否都不支持反算
      const disabledCalc = !this.isPositive && !this.isNegative
      // 判断生产日期和效期是否已经通过扫码获取到值，如果已经获取到值则不推算
      if (disabledCalc || (scan.periodBegin && _periodEnd)) {
        return result
      }
      // 确保参与反算日期的 periodEnd 的值是优先取 periodExpire 后的值
      if (_periodEnd) scan.periodEnd = _periodEnd
      // 商品日期相关
      const period = this.goodsInfo?.period ?? {}
      const options = {
        scan,
        unit: period.unit?.name,
        calc: period.calc?.name,
        life: period.life,
      }

      // 没有推算方式或保质期，则系统不进行推算
      if (!options.calc || !options.life) {
        if (!options.life) {
          console.warn('保质期数据不存在，不反算...')
          console.warn('options: ', options)
          console.warn('period: ', period)
          // this.$Message.info({
          //   content: '保质期数据不存在，不反算...',
          //   duration: 2,
          // })
        }
      } else {
        if (options.unit === '日' || !options.unit) {
          result = { ...result, ...this.dayCompute(options) }
        }
        if (options.unit === '月') {
          result = { ...result, ...this.mouthCompute(options) }
        }
        if (options.unit === '年') {
          result = { ...result, ...this.yearCompute(options) }
        }
      }

      console.log('反算日期的结果: ', result)
      return result
    },
    /**
     * 效期单位为 日 时推算方法
     *
     * @param {Object} options 配置
     * @param {Object} options.scan 扫码获取到日期 { periodBegin, periodEnd, periodExpire }
     * @param {String} options.calc 计算的类型：eg. 按月
     * @param {Number} options.life 保质期
     * @returns {Object} result 返回的结果 eg. { periodBegin, periodEnd, periodExpire }
     */
    dayCompute(options = {}) {
      const { scan, calc, life } = options
      const result = {}
      let model

      /********** 判断 calc 确定算法 **********/
      // 算法：按日（失效日期）unitOneDay = 0
      // 算法：按日 注 按月和按年默认以此算法反算日期 unitOneDay = oneDay
      const oneDay = 24 * 3600 * 1000
      const unitOneDay = /失效日期/g.test(calc) ? 0 : oneDay
      // 正向
      if (this.isPositive && scan?.periodBegin) {
        model = scan?.periodBegin
        const beginTime = new Date(model).getTime()
        const bgDate = new Date(beginTime + life * oneDay)
        if (calc === '按月') bgDate.setDate(bgDate.getDate()) // #35805, 优化日期反算
        const expireTime = bgDate.getTime() - unitOneDay
        result.periodBegin = model
        result.periodEnd = calc ? this.fomatDate(new Date(expireTime)) : null
      }
      // 反向
      else if (this.isNegative && (scan?.periodEnd || scan?.periodExpire)) {
        model = scan?.periodEnd || scan?.periodExpire
        const expireTime = new Date(model).getTime() + unitOneDay
        const bgDate = new Date(expireTime - life * oneDay)
        if (calc === '按月') bgDate.setDate(bgDate.getDate()) // #35805, 优化日期反算
        const beginTime = bgDate.getTime()
        result.periodBegin = this.fomatDate(new Date(beginTime))
        result.periodEnd = model
      }

      return result
    },
    /**
     * 效期单位为 月 的推算方法
     *
     * @param {Object} options 配置
     * @param {Object} options.scan 扫码获取到日期 { periodBegin, periodEnd, periodExpire }
     * @param {String} options.calc 计算的类型：eg. 按月
     * @param {Number} options.life 保质期
     * @returns {Object} result 返回的结果 eg. { periodEnd, periodExpire }
     */
    mouthCompute(options = {}) {
      const { scan, calc, life } = options
      const result = {}
      let model

      /********** 判断 calc 确定算法 **********/
      // 算法：按日（失效日期）unitOneDay = 0
      // 算法：按日 注 按月和按年默认以此算法反算日期 unitOneDay = oneDay
      const oneDay = 24 * 3600 * 1000
      const unitOneDay = /失效日期/g.test(calc) ? 0 : oneDay
      // 正向
      if (this.isPositive && scan?.periodBegin) {
        model = scan?.periodBegin
        const bgDate = new Date(model)
        const mouth = bgDate.getMonth() + life
        if (mouth > 11) {
          calc === '按月' ? bgDate.setMonth(mouth % 12, 1) : bgDate.setMonth(mouth % 12)
          bgDate.setFullYear(bgDate.getFullYear() + Math.floor(mouth / 12))
        } else {
          calc === '按月' ? bgDate.setMonth(mouth, 1) : bgDate.setMonth(mouth)
        }
        const expireTime = bgDate.getTime() - unitOneDay
        result.periodBegin = model
        result.periodEnd = calc ? this.fomatDate(new Date(expireTime)) : null
      }
      // 反向
      else if (this.isNegative && (scan?.periodEnd || scan?.periodExpire)) {
        model = scan?.periodEnd || scan?.periodExpire
        const expireTime = new Date(model).getTime() + unitOneDay
        const bgDate = new Date(expireTime)
        const mouth = bgDate.getMonth() - life
        if (mouth > 11) {
          calc === '按月' ? bgDate.setMonth(mouth % 12, 1) : bgDate.setMonth(mouth % 12)
          bgDate.setFullYear(bgDate.getFullYear() + Math.floor(mouth / 12))
        } else {
          calc === '按月' ? bgDate.setMonth(mouth, 1) : bgDate.setMonth(mouth)
        }
        const beginTime = bgDate.getTime()
        result.periodBegin = this.fomatDate(new Date(beginTime))
        result.periodEnd = model
      }

      return result
    },
    /**
     * 效期单位为 年 的推算方法
     *
     * @param {Object} options 配置
     * @param {Object} options.scan 扫码获取到日期 { periodBegin, periodEnd, periodExpire }
     * @param {String} options.calc 计算的类型：eg. 按年
     * @param {Number} options.life 保质期
     * @returns {Object} result 返回的结果 eg. { periodEnd, periodExpire }
     */
    yearCompute(options = {}) {
      const { scan, calc, life } = options
      const result = {}
      let model

      /********** 判断 calc 确定算法 **********/
      // 算法：按日（失效日期）unitOneDay = 0
      // 算法：按日 注 按月和按年默认以此算法反算日期 unitOneDay = oneDay
      const oneDay = 24 * 3600 * 1000
      const unitOneDay = /失效日期/g.test(calc) ? 0 : oneDay
      // 正向
      if (this.isPositive && scan?.periodBegin) {
        model = scan?.periodBegin
        const bgDate = new Date(model)
        bgDate.setFullYear(bgDate.getFullYear() + life)
        if (calc === '按月') bgDate.setDate(1)
        const expireTime = bgDate.getTime() - unitOneDay
        result.periodBegin = model
        result.periodEnd = calc ? this.fomatDate(new Date(expireTime)) : null
      }
      // 反向
      else if (this.isNegative && (scan?.periodEnd || scan?.periodExpire)) {
        model = scan?.periodEnd || scan?.periodExpire
        const expireTime = new Date(model).getTime() + unitOneDay
        const bgDate = new Date(expireTime)
        bgDate.setFullYear(bgDate.getFullYear() - life)
        if (calc === '按月') bgDate.setDate(1)
        const beginTime = bgDate.getTime()
        result.periodBegin = this.fomatDate(new Date(beginTime))
        result.periodEnd = model
      }

      return result
    },
    // 返回像 2019-08-12 样式的时间格式
    fomatDate(date) {
      if (date instanceof Date) {
        let year = date.getFullYear()
        let mouth = date.getMonth() + 1
        let day = date.getDate()
        mouth = mouth < 10 ? '0' + mouth : mouth
        day = day < 10 ? '0' + day : day
        return `${year}-${mouth}-${day}`
      } else {
        return date
      }
    },
    //
    resetAnalysis() {
      this.analysisMessages = []
      this.analysisCodeType = null
    },
    // 重置 scanResult
    resetScanResult() {
      this.scanResult.codeType = null
      this.scanResult.origin = null
      this.scanResult.print = null
      this.scanResult.success = false
      this.scanResult.data.clear()
      // 单次扫码结果
      this.scanCurrentResult.clear()
    },
    // 重置错误提示
    resetWarnOrErrorMessage() {
      if (this.warnOrErrorMessage) {
        this.warnOrErrorMessage = ''
        this.warnOrErrorMessageType = ''
        if (this.errorMessage) this.$set(this.errorMessage, null)
      }
    },
    // 更新警告或错误信息和类别
    updateWarnOrErrorMessage(message, type = 'error') {
      if (type !== 'error' && type !== 'warn') {
        throw new Error('type 不可为空！且必须是 warn 或 error')
      }
      if (!message) {
        console.error(`message 为空，则不显示警告或错误提示`)
        return
      }
      this.warnOrErrorMessage = message
      this.warnOrErrorMessageType = type
    },
    updateCodeType(type) {
      this.analysisCodeType = type || '普通码'
    },
    /********** 组件部分 **********/
    // 生成扫码表单初始值
    setAreaColumns(arr = ['diAreaColumns']) {
      const regAndCertArr = [
        `${this.dataGoodsKeepingKey}.registration`,
        `${this.dataGoodsKeepingKey}.certification`,
      ]
      arr.forEach((item) => {
        this[item]?.forEach((column, index) => {
          // 忽略注册证号、生产许可证号的表单项
          if (!regAndCertArr.includes(column.code)) {
            const urlQuery = column.parameter?.urlQuery
            const method = (column.parameter?.requestMethod ?? 'get').toLowerCase()
            // 配置时注意，GET 请求时，需要配置到 column.parameter.requestParameters.params 中
            const params = { ...column.parameter?.requestParameters }
            const labelKey = column.props?.labelKey ?? 'label'
            const valueKey = column.props?.valueKey ?? 'value'
            let options = []
            if (urlQuery) {
              this.$axios[method](urlQuery, params).then((res) => {
                res?.data?.data?.forEach((cur) => {
                  if (cur)
                    options.push({ ...cur, [labelKey]: cur[labelKey], [valueKey]: cur[valueKey] })
                })
                this.$set(this[item], index, { ...column, props: { ...column.props, options } })
                // 初始化验收结论为合格
                if (
                  column.code === 'attrs.valueEnum.acceptResult' ||
                  column.code === 'acceptStatus'
                ) {
                  objectUtil.setValueByPath(
                    this.scanFormData,
                    column.code,
                    this.acceptResultDefault
                  )
                }
              })
            }
          }
        })
      })
    },
    setAreaColumnsForRegAndCert(goods, arr = ['diAreaColumns']) {
      const regAndCertArr = [
        `${this.dataGoodsKeepingKey}.registration`,
        `${this.dataGoodsKeepingKey}.certification`,
      ]
      arr.forEach((item) => {
        this[item]?.forEach((column, index) => {
          // 处理注册证号、生产许可证号的表单项
          if (regAndCertArr.includes(column.code)) {
            const goodsId = goods ? goods?.id : this.scanFormData[this.dataGoodsInfoKey]?.id
            if (goodsId) {
              this.$set(this[item], index, { ...column, props: { ...column.props, goodsId } })
            }
          }
        })
      })
    },
    // 判断确认提交按钮是否可点击
    canConfirm() {
      let isConfirm = true
      const requiredArr = [this.piAreaColumns, this.otherAreaColumns]
      requiredArr.forEach((arr) => {
        if (arr?.length) {
          arr.forEach((item) => {
            if (item.props?.required) {
              const val = objectUtil.getValueByPath(this.scanFormData, item.code)
              if (!val && val !== 0 && val !== false) isConfirm = false
            }
          })
        }
      })
      return !this.isSave && isConfirm
    },
    // 判断扫码模式
    getScanType() {
      const result = this.scanResult
      const isMa = result.codeType ? /^MA/i.test(result.codeType) : false // MA
      const isHibc = result.codeType ? /^HIBC/i.test(result.codeType) : false // HIBC
      const isGS1 = result.codeType ? /^GS1/i.test(result.codeType) : false // GS1
      const isHw = result.codeType ? /^HW/i.test(result.codeType) : false // 货位

      return { isMa, isHibc, isGS1, isHw }
    },
    // 查找表单项的元素
    searchFormItem(propName, arr = [this.diAreaColumns]) {
      if (!propName) throw new Error('请传入参数 propName，eg. goodsDetail.name')
      let searchItem
      const columns = arr || []
      const regx = new RegExp(propName)

      for (let n = 0; n < columns.length; n++) {
        const column = columns[n] || []
        for (let m = 0; m < column.length; m++) {
          const item = column[m]
          if (regx.test(item.code)) {
            searchItem = item
            searchItem.nIndex = m
            break
          }
        }
        if (searchItem) break
      }

      return searchItem
    },
    // 判断 scanTableData.length 是否为 0，如果是则给出错误提示。适用于需求#5797
    ifEmptyForScanTableData(errorMessage) {
      const data = this.scanTableData
      if (lodashUtils.isEmpty(data)) {
        this.updateWarnOrErrorMessage(errorMessage ?? '没有匹配到任务或库存', 'error')
      }
    },
    seachScanTableData(goodsKeeping, location) {
      console.log('search scan table data params: ', goodsKeeping)
      let paramMap = new Map()
      if (location) {
        paramMap.set('location.id', location?.id)
      }
      if (this.scanFormData[this.dataGoodsInfoKey].id)
        paramMap.set(`${this.dataGoodsInfoKey}.id`, this.scanFormData[this.dataGoodsInfoKey].id)
      for (let key in goodsKeeping) {
        if (
          key !== 'periodEnd' &&
          key !== 'periodExpire' &&
          key !== 'location' &&
          (goodsKeeping[key] || goodsKeeping[key] === 0)
        )
          paramMap.set(`${this.dataGoodsKeepingKey}.${key}`, goodsKeeping[key])
      }
      //开始搜索
      const tempArr = this.dataSource.filter((item) => {
        let temp = true
        for (let [key, val] of paramMap) {
          if (objectUtil.getValueByPath(item, key) !== val) {
            temp = false
            break
          }
        }
        return temp
      })
      //只过滤主行和待处理数量大于已扫数量的行
      if (this.treeRes && tempArr?.length) {
        let dataMap = new Map()
        this.tableData.map((item) => {
          let temp = dataMap.get(item.parent)
          if (temp) {
            temp.push(item)
          } else {
            dataMap.set(item.parent, [item])
          }
        })
        return tempArr.filter((item) => {
          let tempData = dataMap.get(item.parent)
          if (
            tempData &&
            item.master &&
            item.plan >
              tempData.reduce(
                (acc, cur) => calculateUtil.numberAdd(acc, cur[this.dataAmountKey]),
                0
              )
          ) {
            return true
          } else {
            return false
          }
        })
      } else {
        return tempArr
      }
    },
    // 扫码后查询表格数据
    async queryTableDataList(params = {}, row = null) {
      // 一般只会在扫码组件: scanTable 配置此 props.goodInfoTableColumnDefUrl
      if (!this.goodInfoTableColumnDefUrl) return
      const scanTableDataInfoUrl = this.scanTableDataInfoUrl
      // 根据 di 表单项获取参数
      const _params = this.diAreaColumns.reduce((prev, column) => {
        // 获取表单项的值，有值则赋值
        const val = objectUtil.getValueByPath(this.scanFormData, column.code)
        objectUtil.setValueByPath(prev, column.code, val)

        return { ...prev }
      }, {})
      // 获取扫码解析项的值，有值则赋值
      const { data: scanData } = this.scanResult
      // 扫码类别为自定义序列号时
      if (!scanData.get('epc') && this.scanType === 'CUSTOM_SERIALNUMBER')
        scanData.set('epc', this.scanResult.origin)

      const _paramsExtend = {
        periodBegin: scanData.get('periodBegin') || row?.[this.dataGoodsKeepingKey]?.periodBegin,
        periodEnd: scanData.get('periodEnd') || row?.[this.dataGoodsKeepingKey]?.periodEnd,
        periodExpire: scanData.get('periodExpire') || row?.[this.dataGoodsKeepingKey]?.periodExpire,
      }
      if (row) this.goodsInfo = objectUtil.clone(row)
      const goodsInfo = this.goodsInfo
      // 是否开启序列号管理
      const isSerial =
        this.scanType === 'CUSTOM_SERIALNUMBER' ||
        goodsInfo.keepingSerial ||
        goodsInfo.keepingCustomSerial ||
        goodsInfo.keepingRfidSerial ||
        goodsInfo.keepingExclusiveSerial
      // 如果开启了序列号管理，并配置了表单则赋值
      if (isSerial) {
        const _item = _params[this.dataGoodsKeepingKey] ?? {}
        // 配置了原厂序列号
        if (Object.prototype.hasOwnProperty.call(_item, 'serialNumber')) {
          _paramsExtend.serialNumber = scanData.get('serialNumber')
        }
        // 配置了自定义序列号，Bug#30986
        if (
          this.scanType === 'CUSTOM_SERIALNUMBER' ||
          Object.prototype.hasOwnProperty.call(_item, 'epc')
        ) {
          _paramsExtend.epc = scanData.get('epc')
        }
      }
      // 判断货位是否是可录入的，如果是可录入的，则不将货位装入 _paramsExtend 中
      const locationItem = this.searchFormItem('location')
      if (locationItem?.props?.disabled === true) {
        // 货位不可录入
        _paramsExtend.location = scanData.get('location')
      }

      // 将 _paramsExtend 上面的各属性，赋值给 _params[this.dataGoodsKeepingKey]
      Object.keys(_paramsExtend).forEach((path) => {
        objectUtil.setValueByPath(_params[this.dataGoodsKeepingKey], path, _paramsExtend[path])
      })

      //
      const detailId = objectUtil.getValueByPath(this.scanFormData, `${this.dataGoodsInfoKey}.id`)

      //如果未配置查询接口，说明此处是前端搜索
      if (!scanTableDataInfoUrl) {
        const _data = this.seachScanTableData(
          _params[this.dataGoodsKeepingKey],
          _paramsExtend?.location
        )

        // 扫码后查询到的商品信息集
        this.scanTableData = _data ?? []
        // 判断是否匹配到任务，如果未匹配则给出错误提示
        this.ifEmptyForScanTableData(this.nodataErrorMessage)

        return
      }

      const goodsId = row?.[this.dataGoodsInfoKey]?.id || detailId
      const goodsKeepingParams = _params[this.dataGoodsKeepingKey]
      const locationId = this.scanFormData.location?.id
      //如果有items，就将上表传给后端
      if (this.scanTableDataInfoParam?.parameters?.items) {
        this.scanTableDataInfoParam.parameters.items = this.tableData
      }
      const parameters = {
        ...this.scanTableDataInfoParam,
        parameters: {
          ...params,
          ...this.scanTableDataInfoParam?.parameters,
          ...goodsKeepingParams,
          locationId,
          goodsId,
        },
      }
      // 状态：编辑时
      const targetId = goodsInfo?.[this.dataGoodsKeepingKey]?.target?.id
      // 修改传递的参数中 targetId 的 keyName，目前改为 targetOrgId。注意：即使配置了 targetOrgId，但依然会以商品的 targetId 值为优先
      if (this.scanStatus === 'update' || !parameters.parameters.targetOrgId) {
        parameters.parameters.targetOrgId = targetId
      }
      // 修复Bug，收货单扫码时点击【编辑】，获取 targetId，如果未获取到值则不传递 targetId
      if (
        Object.prototype.hasOwnProperty.call(parameters.parameters, 'targetId') &&
        (this.scanStatus !== 'update' || !targetId)
      ) {
        delete parameters.parameters.targetId
      }

      // #6553,根据系统策略判断，是否自动设置商品档案的序列号管理
      if (!this.isAutoSerial) {
        if ('serialNumber' in parameters.parameters) {
          delete parameters.parameters.serialNumber
        }
        // 删除值为 undefined 或 null 的参数
        for (const key in parameters.parameters) {
          if (Object.prototype.hasOwnProperty.call(parameters.parameters, key)) {
            if (parameters.parameters[key] == null) delete parameters.parameters[key]
          }
        }
      }

      if (scanTableDataInfoUrl) {
        const res = await this.$axios.post(scanTableDataInfoUrl, parameters).catch((error) => {
          console.error(error?.message)
        })
        if (res.data?.code !== 200) {
          this.updateWarnOrErrorMessage(res.data?.msg || this.nodataErrorMessage, 'error')
        }

        // 扫码后查询到的商品信息集
        this.scanTableData = res.data.data ?? []
        // 判断是否匹配到任务，如果未匹配则给出错误提示
        this.ifEmptyForScanTableData(this.nodataErrorMessage)
      }
    },
    //获取货位信息
    getLocationInfo(code, parameters = {}) {
      return new Promise((resolve, reject) => {
        const params = { ...parameters, ...this.locationScanInfoParams }
        params.code = code

        this.$axios
          .post(this.locationScanInfoUrl, params)
          .then((res) => {
            if (res.data.code !== 200) {
              this.$Message.error({
                content: res.data?.msg,
                duration: 5,
              })
              reject({ success: false, message: res.data?.msg })
              return
            }
            resolve(res.data?.data)
          })
          .catch((error) => {
            console.error(error?.message)
            reject(null)
          })
      })
    },
    // 等待选择规格/型号
    waitSelectModel() {
      return new Promise((resolve, reject) => {
        try {
          this.resolveSelectModel = resolve
        } catch (error) {
          console.error(error?.message)
          reject()
        }
      })
    },
    // 重置表单项（只处理配置了货位的情况）
    resetFormItem() {
      const locationItem = this.searchFormItem('location')
      if (locationItem && locationItem.tip) {
        this.$set(locationItem, 'tip', null)
      }
    },
    /**
     * 选中规格/型号
     *
     * @param {*} item 选中的商品
     * @param {number} item.barcodeAmount 包装/规格 即用此值更新数量
     */
    onSelectModel(item) {
      console.log('选中的规格/型号: ', item)
      // 已选中规格/型号，执行 this.resolveSelectModel
      if (this.resolveSelectModel) this.resolveSelectModel(item)
      this.onCancelSelectModel()
      this.$emit('on-select-model', item.model, item)
    },
    // 关闭选规格/型号
    onCancelSelectModel() {
      this.medicalData = null
      this.isSelectModel = false
      // 焦点自动移入扫码输入框
      this.$refs.areaScanInput.focus()
    },
    onClose() {
      return new Promise(() => {
        if (this.isPureSaving) {
          // 正在保存时不可关闭，修复Bug#32319
          this.$pgMessage.confirm({
            title: '确认要退出扫码吗？',
            content: '正在保存数据，不可关闭！',
            sureBtnText: '确定',
            showCancelBtn: false,
            showSureBtnRight: false,
            onOk: function onOk() {
              this.$emit('on-cancel')
            },
          })
        } else {
          if (this.isSave) {
            this.$pgMessage.confirm({
              title: '确认要退出扫码吗？',
              content: '还有数据未保存，确认关闭？',
              showCancelBtn: false,
              sureBtnText: '放弃保存',
              sureBtnTextRight: '保存并关闭',
              showSureBtnRight: true,
              onOk: () => {
                console.log('放弃保存')
                this.$emit('on-cancel')
                this.onDrawerClose()
              },
              onOkRight: async () => {
                console.log('保存并关闭')
                await this.startSave('on-ok')
                this.onDrawerClose()
              },
            })
          } else {
            this.$emit('on-cancel')
            this.onDrawerClose()
          }
        }
      })
    },
    // 请求后台 获取保质期等其他计算数据
    getLife() {
      const goodsId = this.goodsInfo?.id
      if (this.validDateUrl && goodsId) {
        this.$axios
          .get(this.validDateUrl, {
            params: {
              orderId: this.orderId,
              goodsId: goodsId,
              // item:this.index
            },
          })
          .then((res) => {
            if (res.data.code === 200) {
              if (!this.$cfn.ajax1.isOK(res, this)) return
              const item = res.data.data
              if (item) {
                this.unit = objectUtil.getValueByPath(item, 'goods.period.unit.name')
                this.calc = objectUtil.getValueByPath(item, 'goods.period.calc.name')
                this.life = objectUtil.getValueByPath(item, 'goods.period.life')
              }
            }
          })
      }
    },
    /**
     * @name 获取策略
     * @param {Boolean} [isCreated=false] 是否是生命周期 created 中调用
     *
     */
    getPolicySetting(isCreated = false) {
      if (!this.policy) {
        this.policy = objectUtil.getValueByPath(
          this.$store,
          'state.strategy.strategy.ISCC_TWO_WAY_PERIOD',
          null
        )
      }

      if (!isCreated) return

      // #6241，根据页面不同，请求接口更新不同的策略
      this.$axios.get('rest/main/index/getPolicySetting').then((res) => {
        if (!this.$cfn.ajax1.isOK(res, this)) return
        const data = res.data?.data ?? {}
        for (const name in data) {
          if (
            Object.hasOwnProperty.call(data, name) &&
            ['ISCC_GOODS_MANAGE', 'ISCC_STORAGE_MANAGE'].includes(name)
          ) {
            const value = data[name]
            const stateValue = objectUtil.getValueByPath(
              this.$store,
              `state.strategy.strategy.${name}`
            )
            if (value !== stateValue) {
              this.$store.commit('modifySpecifiedStrategy', { name, value })
            }
          }
        }
      })
    },
    //----------------------------扫码确认及之后的逻辑----------------------------------------------
    /**
     * pureSave 保存前处理 res.data 的数据，保持数据顺序和原 formData.items 顺序一致
     *
     * @param {Array} items 传递给 pureSaveOfUrl 接口的商品明细数据
     * @returns {*} formData
     */
    handlePureSaveOfData(items = []) {
      console.log('handlePureSaveOfData...')
      // 原表单，轻易不修改原表单的结构和数据，保持其原样性
      const formData = objectUtil.clone(this.formDataAfterScan ?? this.formData)

      if (!formData.items || formData.items?.length === 0) {
        // 原表单的商品明细 items 无数据，将 items 赋值给 formData.items
        formData.items = items
        return formData
      } else if (!items?.length) {
        // 原表单的商品明细 items 有数据但 items 无数据时，则直接返回 formData
        return formData
      }

      /********** 下面执行主从行或非主从行的重新排序，保持与原表单商品明细的顺序一致 **********/
      let idKey = this.treeRes ? 'parent' : 'id' // true: 主从行，false: 非主从行
      if (this.idKey) idKey = this.idKey

      const itemsMap = objectUtil.arrToMapByKey(items, idKey)
      const modes = ['matchAndImportByItemsForReunion', 'matchAndImportForStockNoParent']
      // 新优联: 快速采购、新建采购退货单(无源)
      if (modes.includes(this.model)) {
        // 获取 items 和 formData.items 的交集和非交集
        const { sames, diffs } = objectUtil.getIntersectionOfArray(formData.items, items, idKey)
        // 有交集
        if (sames.length) {
          // const formItemsMap = objectUtil.arrToMapByKey(formData.items, idKey)
          // for (let [key, val] of formItemsMap) {
          //   let temVal = objectUtil.arrMergeByKey(val, itemsMap.get(key), idKey)
          //   formItemsMap.set(key, temVal)
          // }
          // let tempArr = [...formItemsMap.values()]
          // formData.items = tempArr.reduce((acc, cur) => [...acc, ...cur], [])
          formData.items = sames
          if (diffs.length) formData.items.unshift(...diffs) // 将非交集部分添加到数组的前面（等于新增）
        }
        // 无交集
        else {
          formData.items = [...diffs]
        }

        console.log(sames, diffs)
      }
      // 原扫码的逻辑
      else {
        const formItemsMap = objectUtil.arrToMapByKey(formData.items, idKey)
        for (let [key, val] of formItemsMap) {
          let temVal = objectUtil.arrMergeByKey(val, itemsMap.get(key), '_ID')
          formItemsMap.set(key, temVal)
        }
        let tempArr = [...formItemsMap.values()]
        formData.items = tempArr.reduce((acc, cur) => [...acc, ...cur], [])
      }

      console.log('model: ', this.model)
      console.log('items: ', items)
      console.log('taskData: ', this.taskData)
      console.log('prue save formData: ', formData)
      return formData
    },
    /**
     * 执行保存动作
     * @param {String} eventName 提交的事件名 可选值 on-ok、on-ok-and-continue
     * @param {Function} fnCallback 回调方法，用于执行后续动作
     *
     */
    startSave(eventName) {
      // eslint-disable-next-line no-async-promise-executor
      return new Promise(async (resolve, reject) => {
        if (!eventName) reject('eventName 不可为空！')
        this.topRemindErrors = null
        // 保存前执行
        const res = await this.saveBefore()
        if (res.code === 200) {
          const eventData = {
            data: {
              code: res.code,
              data: res.data,
            },
          }

          // 优联，需求#5559【优联-web-云南骨科】扫码验收支持服务端暂存扫码结果
          if (!this.isLinkOfSystem && this.pureSaveOfUrl && !this.disabledPureSave) {
            let formData = this.handlePureSaveOfData(res.data)

            this.$Loading.start()
            this.isPureSaving = true
            this.$axios
              .post(this.pureSaveOfUrl, formData)
              .then((response) => {
                this.$Loading.finish()
                if (!this.$cfn.ajax1.isOK(response, this)) {
                  this.isPureSaving = false
                  return reject()
                }

                formData = response.data.data // 用接口返回的表单数据，重新赋值了该变量
                // 函数 handlePureSaveOfData 中，会优先使用 formDataAfterScan 的值生成传递给暂存接口的 formData
                this.formDataAfterScan = formData

                eventData.isUpdateFormDataAll = true
                eventData.formData = formData

                this.$emit(eventName, eventData)
                // 保存成功后
                this.isSave = false

                resolve()
              })
              .catch((error) => {
                this.$Loading.error()
                this.$cfn.ajax1.catch1(error, this)
                reject(error.message)
              })
              .finally(() => {
                this.isPureSaving = false
              })
          } else {
            this.$emit(eventName, eventData)
            // 保存成功后
            this.isSave = false

            resolve()
          }
        } else {
          this.topRemindErrors = res
          reject(res.msg)
        }
      })
    },
    // 提交保存
    async onSave() {
      await this.startSave('on-ok-and-continue')
      this.$Message.success('成功')
      this.initComponent(0, true)
    },
    /** @name 更新scanFormData.amount,项目中可能amount的字段不一致 */
    updateAmount(amountKey = this.dataAmountKey) {
      const scanData = this.scanCurrentResult
      // 是否开启序列号，如果开启则序列号为必填
      const ifSerial = scanUtils.ifSerial(
        this.scanFormData,
        `${this.dataGoodsInfoKey}.keepingSerial`
      )
      // 数量取值判断标准
      const amountChoose = this.goodsInfo?.amountChoose ?? 'DEFAULT'
      // 扫到的条码上的数量
      const codeAmount = +scanData.get('amount') || 0
      // 商品信息或扫码组件内输入的数量
      const infoAmount = +this.goodsInfo?.[amountKey] || +this.scanFormData?.[amountKey] || 0
      // 包装规格数量
      const barcodeAmount = +this.goodsInfo?.barcodeAmount || 0
      // 辅助单位数量
      const unitOtherAmount = +this.goodsInfo?.unitOtherItem?.ratio?.dividend || 0
      // 包装规格或辅助单位数量
      const otherAmount = amountChoose === 'AUXILIARY' ? unitOtherAmount : barcodeAmount
      // 数量
      const amount = ifSerial ? 1 : codeAmount || otherAmount || infoAmount || 1

      objectUtil.setValueByPathForVue(this.scanFormData, amountKey, amount, this)
    },
    // 设置参数
    fixParameters(parameters = {}, canFix = false) {
      if (!canFix) return parameters

      const excludes = ['batchNumber', 'goodsId', 'periodBegin', 'periodEnd', 'serialNumber']
      const newParameters = {}
      for (const paramKey in parameters) {
        if (Object.hasOwnProperty.call(parameters, paramKey) && !excludes.includes(paramKey)) {
          newParameters[paramKey] = parameters[paramKey]
        }
      }
      return newParameters
    },
    /**
     * @name 处理beforeEmit的返回值flag
     *
     * @param {*} flag beforeEmit 的返回值
     * @param {*} [options]
     * @param {*} [options.success] 成功回调函数
     * @param {*} [options.fail] 失败回调函数
     * @param {*} [options.finally] 始终执行的回调函数
     * @param {*} [options.disabledThrow] 禁止提示异常
     *
     * 参数 flag 可能的值:
     * 1. Boolean 类型 true: 成功 / false: 失败
     * 2. Object 类型 { msg: 'xxxxx' } 成功
     * 3. String 类型 'xxxxx' 失败时，可直接将此值 throw
     * 4. Undefined 类型 失败或忽略
     *
     * @returns
     */
    handleBeforeEmitReturnValue(flag, options) {
      return new Promise((reslove, reject) => {
        let msg
        if (flag === true || Object.prototype.toString.call(flag) === '[object Object]') {
          msg = flag === true ? '添加成功' : flag?.msg || '添加成功'

          if (options?.success) {
            options?.success.call(this, { msg })
            options?.finally?.call(this)
            reslove()
            return
          }

          this.$Message.success(msg)

          setTimeout(() => {
            this.onClear()
            reslove({ status: true, msg })
          }, 500)
        } else if (flag === false || Object.prototype.toString.call(flag) === '[object String]') {
          msg = flag || '发生异常'

          if (options?.fail) {
            options?.fail.call(this, { msg })
            options?.finally?.call(this)
            reject()
            return
          }

          if (
            Object.prototype.toString.call(flag) === '[object String]' &&
            !options?.disabledThrow
          ) {
            this.updateWarnOrErrorMessage(flag, 'error')
          }
          reject({ status: false, msg })
        } else {
          msg = '可忽略的异常'
          reject({ status: false, msg })
        }

        options?.finally?.call(this)
      })
    },
    /** @name 根据props.checkArr和扫码的各后置逻辑，生成最新的checkArr */
    setCheckArr() {
      const goodsSetting = this.goodsSetting
      console.log('goodsSetting: ', goodsSetting)
      const ifArr = Object.prototype.toString.call(this.checkArr) === '[object Array]'
      let checkArr = ifArr
        ? objectUtil.clone(this.checkArr.map((key) => `${this.dataGoodsKeepingKey}.${key}`))
        : []

      if (checkArr?.length === 0) {
        checkArr.push(
          ...[
            `${this.dataGoodsInfoKey}.id`,
            `${this.dataGoodsKeepingKey}.periodBegin`,
            `${this.dataGoodsKeepingKey}.periodEnd`,
            `${this.dataGoodsKeepingKey}.batchNumber`,
          ]
        )
        // 找出商品档案的生产信息中的注册证号和生产许可证号是否是必填项
        for (const key of Object.keys(goodsSetting)) {
          if (!['certification', 'registration'].includes(key)) continue
          const el = goodsSetting[key]
          const item = this.searchFormItem(`${this.dataGoodsKeepingKey}.${key}`)
          if (el && item) {
            checkArr.push(`${this.dataGoodsKeepingKey}.${key}.id`)
          }
        }
      }
      checkArr = [...new Set(checkArr)]
      const m = new Map()
      for (const checkIndex in checkArr) {
        if (Object.hasOwnProperty.call(checkArr, checkIndex)) {
          const checkKey = (checkArr[checkIndex] || '')?.split('.')?.[1]
          if (checkKey) m.set(checkKey, { status: true, key: checkKey })
        }
      }

      for (const key of Object.keys(goodsSetting)) {
        const el = goodsSetting[key]
        const item = this.searchFormItem(`${this.dataGoodsKeepingKey}.${key}`)
        if (!el || !item) {
          const checkItem = m.get(key)
          if (checkItem?.status)
            checkArr = checkArr.filter((key) => {
              // #35195 删除无值或未配置表单项的校验项
              return key.indexOf(checkItem.key) === -1
            })
        }
      }

      if (!checkArr.includes(`${this.dataGoodsInfoKey}.id`)) {
        checkArr.unshift(`${this.dataGoodsInfoKey}.id`)
      }
      return checkArr
    },
    /** @name 请求获取商品的可编辑实体 */
    async getAdvanceOfGoods(goodsId) {
      const id =
        goodsId || objectUtil.getValueByPath(this.scanFormData, `${this.dataGoodsInfoKey}.id`)
      const res = await this.$axios
        .get(`rest/main/goods/goods/getAdvance?id=${id}`)
        .catch((error) => {
          console.error(error.message)
        })
      if (res.data?.errors) throw new Error(res.data.errors?.[0]?.message ?? '发生异常')
      if (res.data?.code !== 200) throw new Error(res.data?.msg)
      return res?.data?.data ?? {}
    },
    // #8927 执行序列号中截取批号
    onNewBatchNumber() {
      this.setNewBatchNumber()
    },
    // #8927 从序列号中截取批号
    setNewBatchNumber() {
      if (!this.openSerialCutBatchNumber) return
      let tmpFormData = this.scanFormData
      console.log('tmpFormData: ', this.scanFormData)
      const ld = localStorage.getItem(this.cacheId)
      if (ld && ld != '{}') {
        const { count, startPos, prefix, suffix, clear } = JSON.parse(ld)
        tmpFormData.clear = tmpFormData.clear ?? clear
        tmpFormData.count = tmpFormData.count ?? count
        tmpFormData.startPos = tmpFormData.startPos ?? startPos
        tmpFormData.prefix = tmpFormData.prefix ?? prefix
        tmpFormData.suffix = tmpFormData.suffix ?? suffix
      }

      const { prefix, suffix, clear } = tmpFormData
      const startPos =
        tmpFormData.startPos && +`${tmpFormData.startPos}` > 0
          ? +`${tmpFormData.startPos}`
          : undefined
      const count = tmpFormData.count ? +`${tmpFormData.count}` : undefined
      const goodsKeeping = this.scanFormData[this.dataGoodsKeepingKey] // 以输入的优先

      // 正确响应必填校验
      tmpFormData.startPos = startPos
      tmpFormData.count = count

      // 根据设置执行
      if (clear) {
        const scanData = this.scanCurrentResult
        console.log('scanData: ', scanData)
        const batchNubmer = scanData.get('batchNumber')
        const serialNubmer = scanData.get('serialNumber')
        const hasBatchNubmer = ![null, undefined, ''].includes(batchNubmer)
        const hasSerialNubmer = ![null, undefined, ''].includes(serialNubmer)

        console.log(batchNubmer, hasBatchNubmer, serialNubmer, hasSerialNubmer)

        if (hasBatchNubmer && hasSerialNubmer) {
          objectUtil.setValueByPathForVue(this.scanFormData, 'count', null, this)
          objectUtil.setValueByPathForVue(this.scanFormData, 'startPos', null, this)
          objectUtil.setValueByPathForVue(this.scanFormData, 'prefix', null, this)
          objectUtil.setValueByPathForVue(this.scanFormData, 'suffix', null, this)

          localStorage.setItem(
            this.cacheId,
            JSON.stringify({
              count: null,
              startPos: null,
              prefix: null,
              suffix: null,
              clear,
            })
          )
        }
      }

      // 如果序列号有值，但批号为空。开始截取批号
      if (
        goodsKeeping.serialNumber &&
        (goodsKeeping.batchNumber == null || goodsKeeping.batchNumber == '')
      ) {
        const len =
          startPos + count > goodsKeeping.serialNumber.length
            ? goodsKeeping.serialNumber.length + 1
            : startPos + count
        let batchNumber = goodsKeeping.serialNumber.slice(startPos - 1, len - 1)
        batchNumber = `${prefix || ''}${batchNumber}${suffix || ''}`
        objectUtil.setValueByPathForVue(
          this.scanFormData,
          `${this.dataGoodsKeepingKey}.batchNumber`,
          batchNumber,
          this
        )
      }
    },
    // #8927 清空从序列号截取批号的缓存
    clearSetBatchNumberCache() {
      const ld = localStorage.getItem(this.cacheId)
      let clear = false
      if (ld && ld != '{}') {
        const v = JSON.parse(ld)
        clear = v.clear
      }
      localStorage.setItem(
        this.cacheId,
        JSON.stringify({
          count: null,
          startPos: null,
          prefix: null,
          suffix: null,
          clear,
        })
      )
    },
  },
}
